import type { Route } from "./types";

export const ROUTES: Record<string, Route> = {
  /** nav */
  "/": { title: "pages.overview", path: "/" },
  "/invoices": { title: "pages.invoices", path: "/invoices" },
  "/payment-methods": {
    title: "pages.paymentMethods",
    path: "/payment-methods",
  },
  "/notifications": { title: "pages.notifications", path: "/notifications" },
  "/payment-history": {
    title: "pages.paymentHistory",
    path: "/payment-history",
  },
  "/analytics": { title: "pages.analytics", path: "/analytics" },
  "/meters": { title: "pages.meterReadings", path: "/meters" },
  "/consumption": { title: "pages.consumption", path: "/consumption" },

  /** (footer) */
  "/frequently-asked-questions": {
    title: "pages.faqTitle",
    path: "/frequently-asked-questions",
  },
  "/support": { title: "pages.supportTitle", path: "/support" },
  "/feedback": { title: "pages.feedback", path: "/feedback" },
  "/settings": {
    title: "pages.settings",
    path: "/settings",
    children: [
      { title: "pages.settingsAccount", path: "/settings/account" },
      {
        title: "pages.settingsNotifications",
        path: "/settings/notifications",
      },
      {
        title: "pages.settingsSecurity",
        path: "/settings/security-and-access",
      },
      { title: "pages.settingsPreferences", path: "/settings/preferences" },
    ],
  },

  /** misc. pages */
  "/accounts/:accountNumber": {
    title: "pages.accountDetails",
    path: "/accounts/:accountNumber",
  },
  "/accounts": { title: "pages.accounts", path: "/accounts" },
  "/insights": {
    title: "pages.accountInsights",
    path: "/insights",
  },

  "/pay": { title: "pages.makePayment", path: "/pay" },
  "/pay/confirmation": {
    title: "pages.paymentConfirmation",
    path: "/pay/confirmation",
  },
  "/auto-pay": { title: "pages.autoPay", path: "/auto-pay" },
  "/auto-pay/setup": {
    title: "pages.setupAutoPay",
    path: "/auto-pay/setup",
  },
  "/auto-pay/manage": {
    title: "pages.autoPaySettings",
    path: "/auto-pay/manage",
  },
  "/faq": { title: "pages.faqTitle", path: "/faq" },
  "/about-us": { title: "pages.aboutUs", path: "/about-us" },
  "/terms-of-use": { title: "pages.termsOfUse", path: "/terms-of-use" },
  "/privacy": { title: "pages.privacyPolicy", path: "/privacy" },
  "/accessibility": {
    title: "pages.accessibilityTitle",
    path: "/accessibility",
  },

  /** (demos) */
  "/demos/cookie-consent-script": {
    title: "[Demo] Cookie Consent Script",
    path: "/demos/cookie-consent-script",
  },
  "/demos/file-upload": {
    title: "[Demo] File Upload",
    path: "/demos/file-upload",
  },
};
